import { DesignTokens, Row } from "melco-ui";
import styled from "styled-components";
const { fonts } = DesignTokens;

export const MELCO_CLOUD = "MelcoCloud";
export const BERNINA_CLOUD = "BerninaCloud";
export const DEFAULT_FILE_FORMAT = ".csv";
export const FILE_FORMAT_HOOP = ".mhf";
export const FILE_FORMAT_THREAD = ".mcc";
export type CountryType = string;
export type DropDownValueLabelObj = {
  value: string;
  label: string;
};

export const FullWidthRow = styled(Row)`
  width: 100%;
  min-width: 100%;
`;
export const GrayedOutLabel = styled.div`
  font-family: ${fonts.sansSerifMd};
  color: #c6c6c6;
`;

export const HighlightedMenu = styled.div`
  && .ant-dropdown-menu-item:hover {
    color: white;
    background-color: red;
  }

  && .ant-dropdown-menu-item {
    color: black;
  }
`;

/** 
 *  Browser default
    console.log(getDateFormatString());

     locale="en-US" 
    console.log(getDateFormatString('en-us')); // MM/DD/YYYY

    locale="en-GB"
    console.log(getDateFormatString('en-gb')); // DD/MM/YYYY 
 */
export const getDateFormatString = (lang = "default") => {
  const formatObj = new Intl.DateTimeFormat(lang).formatToParts(new Date());

  return formatObj
    .map((obj) => {
      switch (obj.type) {
        case "day":
          return "DD";
        case "month":
          return "MM";
        case "year":
          return "YYYY";
        default:
          return obj.value;
      }
    })
    .join("");
};

export const findInTable = (arr: any, value: any) => {
  value = String(value).toLowerCase();
  return arr.filter((o: any) =>
    Object.entries(o).some((entry) =>
      String(entry[1]).toLowerCase().includes(value)
    )
  );
};

export const safeDivide = (a: any, b: any) => {
  // Check if a and b are numbers (not undefined) and b is not zero
  if (typeof a === "number" && typeof b === "number" && b !== 0) {
    return a / b;
  }

  // Return empty string if invalid
  return "";
};
